import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isInlineFormEnabledForCopilotUsers } from "./isCalendarEventFormV2Enabled";
import { isEnabledForFrontierCopilotAudience, type FrontierFlightConfig, } from "./isEnabledForFrontierCopilotAudience";

const idaDraftAssistantFrontierFlights: FrontierFlightConfig = {
    publicFlight: "time-copilot-ida-draft-assistant-frontier-public",
    privateTapFlight: "time-copilot-ida-draft-assistant-frontier-private-tap",
    privateStagingFlight: "time-copilot-ida-draft-assistant-frontier-private-staging",
    privateInfluencerFlight: "time-copilot-ida-draft-assistant-frontier-private-influencer",
};

/**
 * Checks if the Event Draft Assistant (BizChat sidepane) experience is enabled.
 * The conditions for enabling include feature flag(time-copilot-ida-draft-assistant), user copilot license, user copilot settings and event form copilot experience capability.
 * When enabled, routes calendar draft requests to the BizChat sidepane instead of inline skittle.
 *
 * Returns true if EITHER:
 * - The global `time-copilot-ida-draft-assistant` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isEventDraftAssistantEnabled(mailboxInfo: MailboxInfo): boolean {
    return ((isGlobalFeatureEnabled("time-copilot-ida-draft-assistant") ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, idaDraftAssistantFrontierFlights)) &&
        isInlineFormEnabledForCopilotUsers());
}

/**
 * Checks if the Event Draft Assistant is enabled for existing events.
 * When enabled, the button is shown on form open for existing events.
 * Gated by a separate flight so existing-event support can be rolled out independently.
 */
export function isEventDraftAssistantEnabledForExistingEvents(): boolean {
    return (isGlobalFeatureEnabled("time-copilot-ida-existing-events") &&
        isInlineFormEnabledForCopilotUsers());
}
